module.exports = __webpack_public_path__ + "img/home-bg-3.9b89d7c3.png";